
export default {
  inheritAttrs: false,
  props: {
    product: {
      type: Object,
      default: null
    },
    detailed: {
      type: Boolean,
      default: false
    },
    label: {
      type: Boolean,
      default: true
    }
  },
  vessel: {
    label: {
      textColor: 'grey-darker',
      display: 'block',
      whiteSpace: 'no-wrap'
    },
    price: {
      display: 'block',
      fontWeight: 'semibold',
    },
    strike: {
      color: 'grey-darkest',
      fontWeight: 'semibold'
    },
    finalPrice: {
      color: 'primary',
      fontWeight: 'bold',
      fontSize: 'md'
    }
  },
  computed: {
    hasVariants() {
      return this.product.variantsCount > 0
    },
    text() {
      return this.hasVariants ? this.$t('product.priceFrom') : this.$t('price')
    }
  }
}
